module.exports = __webpack_public_path__ + "assets/img/mjzz.c946f29e.jpg";